import { NodeViewConstructor } from '@tiptap/pm/view';
import { Editor } from '@tiptap/react';
import { FunctionComponent, memo, PropsWithChildren, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseButton } from '../../../../CloseButton';

import classNames from 'classnames';
import classes from './CloseWrapper.module.scss';

interface CloseWrapperProps {
  editor: Editor;
  node: Parameters<NodeViewConstructor>[0];
  getPos: () => number | undefined;
  loading?: boolean;
  className?: string;
}

export const CloseWrapper: FunctionComponent<PropsWithChildren<CloseWrapperProps>> = memo(
  ({ editor, node, getPos, loading, className, children }) => {
    const { t } = useTranslation();

    const onClick = useCallback(() => {
      const pos = getPos();

      if (typeof pos === 'number') {
        editor.commands.deleteRange({ from: pos, to: pos + node.nodeSize });
      }
    }, [editor.commands, getPos, node.nodeSize]);

    return (
      <div className={classNames(classes['wrapper'], className)}>
        {children}
        {!loading && (
          <CloseButton
            className={classes['wrapper__close']}
            onClick={onClick}
            ariaLabel={t('common.remove')}
          />
        )}
      </div>
    );
  }
);
